import { getAircraftDocumentsForAircraft } from '../AircraftDocuments/AircraftDocuments';
import { getLastCountableChangeForAircraft } from '../CountableChanges/CountableChangeDatasource';
import { getFlightsForAircraft } from '../Flights/getFlightsForAircraft';
import { getReleaseToServicesForAircraft } from '../ReleaseToService/ReleaseToServiceDatasource';
import { getSquawksForAircraft } from '../Squawks/getSquawksForAircraft';
import { type AircraftForFlight } from './AircraftForFlight';
import {
    getAircraft,
    type GetAircraftForFlightParams,
    getAircraftMaintenanceLimitExtensionsForLimits,
    getAircraftMaintenanceLimits,
} from './AircraftsDatasource';

export async function getAircraftForFlight(
    aircraftId: GetAircraftForFlightParams[0]
): Promise<AircraftForFlight | null> {
    const aircraft = await getAircraft(aircraftId);
    if (aircraft === null) {
        return null;
    }
    const [flights, squawks, lastCountableChange, aircraftMaintenanceLimits, releases] = await Promise.all([
        getFlightsForAircraft(aircraftId),
        getSquawksForAircraft(aircraftId),
        getLastCountableChangeForAircraft(aircraftId),
        getAircraftMaintenanceLimits(aircraftId),
        getReleaseToServicesForAircraft(aircraftId),
    ]);
    const maintenanceLimitIds = aircraftMaintenanceLimits.map((aml) => aml.id);
    const [aircraftDocuments, aircraftMaintenanceLimitExtensions] = await Promise.all([
        getAircraftDocumentsForAircraft(aircraftId),
        await getAircraftMaintenanceLimitExtensionsForLimits(maintenanceLimitIds),
    ]);
    return {
        ...aircraft,
        flights,
        squawks,
        lastCountableChange,
        aircraftDocuments,
        aircraftMaintenanceLimits,
        aircraftMaintenanceLimitExtensions,
        releases,
    };
}
